import React from "react"
import { Slot } from "@radix-ui/react-slot"

import { IKTRichText } from "@/types/kontent.types"
import { cn } from "@/lib/utils"
import {
  Link,
  RichTextSync,
  TLinkProps,
  Typography,
} from "@/components/ui/atoms"

interface IHighlightedContentProps {
  asChild?: boolean
  className?: string
  title: string
  content: IKTRichText
  isInArticle?: boolean
  storybookButton?: TLinkProps
}

const HighlightedContent = React.forwardRef<
  HTMLDivElement,
  IHighlightedContentProps
>(
  (
    {
      className,
      asChild,
      isInArticle = false,
      title,
      content,
      storybookButton,
    },
    ref
  ) => {
    const Component = asChild ? Slot : "div"
    return (
      <Component
        ref={ref}
        className={cn(
          "mt-6 rounded-100",
          className,
          isInArticle ? "" : "container py-10 lg:py-17"
        )}
      >
        <div className="flex items-center justify-between rounded-t-100 bg-secondary-500 px-9 py-6">
          <Typography as="h3" variant="headingS" className="mb-0">
            {title}
          </Typography>
        </div>
        <div
          className={cn(
            "paragraph-m rounded-b-100 bg-neutral-100 px-9 pb-7 pt-9"
          )}
        >
          {content ? (
            <RichTextSync
              rightAlignButtons={true}
              blockTitle={title}
              body={content}
            />
          ) : null}
          {storybookButton ? (
            <span className="flex justify-end pb-5">
              <Link
                chapters={[]}
                variant={storybookButton.variant}
                iconRight={storybookButton.iconRight}
                iconLeft={storybookButton.iconLeft}
                href={storybookButton.href}
              >
                {storybookButton.children}
              </Link>
            </span>
          ) : null}
        </div>
      </Component>
    )
  }
)

HighlightedContent.displayName = "HighlightedContent"

export { HighlightedContent, type IHighlightedContentProps }
